import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Reminder } from '../models/reminder';

export interface RelatedContext {
    messageId?: string;
    messageText?: string;
    chatId?: string;
    chatDisplayName?: string;
    imageUrls?: string[];
    videoUrls?: string[];
    replyQuote?: string;
}

export interface RemindersUIState {
    draftReminder?: Partial<Reminder> | null;
    // Test Reminder Dialog State
    testReminderOpen: boolean;
    testReminderData: Reminder | null;
    // Editor State
    isEditing: boolean;
    editingReminder: Reminder | undefined;
    relatedContext: RelatedContext;
}

const initialState: RemindersUIState = {
    draftReminder: null,
    testReminderOpen: false,
    testReminderData: null,
    isEditing: false,
    editingReminder: undefined,
    relatedContext: {},
};

export const remindersUISlice = createSlice({
    name: 'remindersUI',
    initialState,
    reducers: {
        setDraftReminder: (state, action: PayloadAction<Partial<Reminder> | null>) => {
            state.draftReminder = action.payload;
        },
        // Test Reminder Dialog Actions
        openReminderDialog: (state, action: PayloadAction<Reminder>) => {
            state.testReminderOpen = true;
            state.testReminderData = action.payload;
        },
        closeTestReminderDialog: (state) => {
            state.testReminderOpen = false;
            state.testReminderData = null;
        },
        // Editor Actions
        openEditor: (state, action: PayloadAction<{ reminder?: Reminder; context?: RelatedContext }>) => {
            state.isEditing = true;
            state.editingReminder = action.payload.reminder;
            state.relatedContext = action.payload.context || {};
        },
        closeEditor: (state) => {
            state.isEditing = false;
            state.editingReminder = undefined;
            state.relatedContext = {};
        },
        setEditingReminder: (state, action: PayloadAction<Reminder | undefined>) => {
            state.editingReminder = action.payload;
        },
        setRelatedContext: (state, action: PayloadAction<RelatedContext>) => {
            state.relatedContext = action.payload;
        },
    },
});

export const { 
    setDraftReminder,
    openReminderDialog,
    closeTestReminderDialog,
    openEditor,
    closeEditor,
    setEditingReminder,
    setRelatedContext,
} = remindersUISlice.actions;

export default remindersUISlice.reducer;

// Selectors
export const selectDraftReminder = (state: any) => state.RemindersUIReducer.draftReminder;
export const selectTestReminderOpen = (state: any) => state.RemindersUIReducer.testReminderOpen;
export const selectTestReminderData = (state: any) => state.RemindersUIReducer.testReminderData;
export const selectIsEditing = (state: any) => state.RemindersUIReducer.isEditing;
export const selectEditingReminder = (state: any) => state.RemindersUIReducer.editingReminder;
export const selectRelatedContext = (state: any) => state.RemindersUIReducer.relatedContext;
